import {inject} from '@angular/core';
import {CanActivateFn, CanMatchFn, Router} from '@angular/router';
import {Store} from "@ngxs/store";
import * as Sentry from "@sentry/angular";

export function checkIfFlowIdIsStoredGuard(): CanActivateFn | CanMatchFn {
  return () => {
    const store: Store = inject(Store);
    if (store.selectSnapshot(state => state.whitebricks.flowId)) {
      return true;
    } else {
      Sentry.captureException(new Error('Required parameter flowId was null or undefined. Required parameter flowId was not stored in session storage.'));
      const router: Router = inject(Router);
      router.navigate(['/error']);
      return false;
    }
  };
}
